import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseShape } from '../base-shape/component.js';
import { pathsMap } from './paths.js';

var SuperEllipse = forwardRef(function (props, ref) { return (React.createElement(BaseShape, __assign({}, props, { pathsMap: pathsMap, ref: ref }))); });
SuperEllipse.displayName = 'SuperEllipse';

export { SuperEllipse };
